<template>
  <div>
    <CDataTable
        :table-filter="{label:''}"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="item"
        :fields="fields"
        :items-per-page="small ? 50 : 20"
        :dark="dark"
        pagination
    >

      <template #index="{item,index}">
        <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
      </template>

      <template #status="{item,index}">
        <td class="text-left" @click="toggleDetails(item, index)">
          {{ getStatusValue(item) }}
          <samp v-if="showAssessor(item)">
            : {{ item.assessor }}
          </samp>
        </td>
<!--        <td class="text-left"  @click="toggleDetails(item, index)"> {{item.status.filter(obj => { return (obj.key == lang) })[0].value}} <samp v-if="item.status.filter(obj => { return (obj.key === lang) }).at(-1)._id.toString() !== '654851a37ab25be71bbeeed7'">: {{ item.assessor }} </samp> </td>-->
      </template>

      <template #position="{item,index}">
        <td class="text-left"  @click="toggleDetails(item, index)"> {{item.position.filter(obj => { return (obj.key == lang) })[0].value}}</td>
      </template>




      <template #action="{item,index}">
        <td style="width: 140px">
          <CRow>
            <CCol class="text-center">
<!--              <CButton  v-if="item.status.filter(obj => { return (obj.key === lang) }).at(-1)._id.toString() === '654851a37ab25be71bbeeed7'" class="mr-1 "  size="sm" color="info" shape="pill" variant="outline" @click="onAssessmentIDP(item, index)"  >-->
<!--                <CIcon name="cil-clipboard"/>-->
<!--              </CButton>-->

              <CButton :disabled="!item.disable" class="mr-1 "  size="sm" color="info" shape="pill" variant="outline" @click="onAssessment(item, index)"  >
                <CIcon name="cil-description"/>
              </CButton>


              <CButton class="mr-1"  size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                <CIcon :name="(item._toggled === true)?'cil-chevron-bottom':'cil-chevron-right'"/>
              </CButton>


            </CCol>
          </CRow>
        </td>
      </template>



      <template #details="{item}">
        <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
<!--          {{ onCheckLevel(item.value.positions)}} -->
<!--          {{ onCheckLevel(item.value.accounts.positions)}}-->
<!--          :year="item.year"-->
          <EDCompetency  :default-datasets="objs.datasets" :points="objs.points" v-for="(objs, idx) in item.value.item" :key="objs.id || idx" :item="objs" :levels="onCheckLevel(item.value.accounts.positions)"/>
        </CCollapse>
      </template>


    </CDataTable>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import EDCompetency from "@/projects/views/E-Performances/Dashboard/users/components/EDCompetency";

export default {
  name: 'History',
  components: {EDCompetency},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },
    item:{
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          // {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"avata", label:"", _style: 'width:50px; text-align: center'},
          {key:"members", label:"Member",  _style: 'width:200px;'},
          {key:"calss", label:"Class Info",},
          {key:"dateTime", label:"Last Update",  _style: 'width:190px;'},
          // {key:"action", label: "#"}
          // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  data: function () {
    return {

      collapseDuration: 0,
      isDialog: false,




    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    onAssessmentIDP (item,index) {
      item.isIDP = true;
      this.$emit('info',item)
    },

    onAssessment (item,index) {
      item.isIDP = false;
      this.$emit('info',item)
    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    onSetLevel(item){
      return 4
    },
    onCheckLastFields(item){
      return item[item.length-1]
    },
    onCheckLevel(data) {

      var level = 1;
      var objs = this.onCheckLastFields(data)
      if(objs.type && objs.type.control != null){
        const start = moment(objs.startDate);
        const end =  moment().set("month",8).set("date",30).add(-2,"year"); // หากไม่มี endDate ให้ใช้วันที่ปัจจุบัน

        console.log(end)

        const years = end.diff(start, 'years');
        level = objs.type.control.filter((item) => { return (item.year >= years) })[0].level

        console.log(objs.type.control)
        console.log(objs.type.control.filter((item) => { return (item.year >= years) })[0])
      }

      if(objs.work && objs.work.control != null){
        level= objs.work.control[objs.work.control.length-1].level;
      }

      if(objs.name && objs.name.control != null){
        level = objs.name.control[objs.name.control.length-1].level;
      }

      console.log(level)
      return level;
    },

    getStatusByLang(item) {
      if (!item.status || !Array.isArray(item.status)) return null
      return item.status.find(s => s.key === this.lang) || null
    },

    getStatusValue(item) {
      const status = this.getStatusByLang(item)
      return status ? status.value : '-'
    },

    showAssessor(item) {
      const status = this.getStatusByLang(item)
      if (!status || !status._id) return false
      return status._id.toString() !== '654851a37ab25be71bbeeed7'
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
